module.exports = "<div class=\"item user-block\" *ngIf=\"userBlockIsVisible()\">\r\n    <!-- User picture-->\r\n    <div class=\"date\" now format=\"DD/MM/YY\"></div>\r\n    <div class=\"date\" now format=\"HH:mm\"></div>\r\n    <!-- Name and Job-->\r\n    <div class=\"user-block-info\">\r\n        <span class=\"user-block-name\">{{user.name}}</span>\r\n        <span class=\"user-block-role\">{{user.role}}</span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/core/layout/sidebar/userblock/userblock.component.html
// module id = ../../../../../src/app/core/layout/sidebar/userblock/userblock.component.html
// module chunks = main